module.exports = __webpack_public_path__ + "img/galleria6.346cfbdb.jpg";